import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="mb-4 flex items-center gap-3 font-mono text-[11px] font-medium uppercase tracking-[0.3em] text-indigo-300/90">
    <span className="h-px w-8 bg-gradient-to-r from-indigo-400 to-transparent" />
    {children}
  </p>
);

export const SectionHeading = ({ eyebrow, title, sub, center = false }) => (
  <div className={center ? "text-center" : ""}>
    {eyebrow && (
      <div className={center ? "flex justify-center" : ""}>
        <Eyebrow>{eyebrow}</Eyebrow>
      </div>
    )}
    <Reveal>
      <h2 className="font-display text-3xl font-bold leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.1}>
        <p
          className={`mt-4 max-w-2xl text-base leading-relaxed text-slate-400 ${
            center ? "mx-auto" : ""
          }`}
        >
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);
